import { useBoolean } from '@dreryk/react-common';

import { CustomPatientGroupsRemoveModal } from './CustomPatientGroupsRemoveModal';

type CustomPatientGroupsRemoveModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type CustomPatientGroupsRemoveModalOpenerProps = {
   children: (renderProps: CustomPatientGroupsRemoveModalOpenerRenderProps) => JSX.Element;
   patientGroupId: number;
   patientGroupName: string;
};

export const CustomPatientGroupsRemoveModalOpener = (props: CustomPatientGroupsRemoveModalOpenerProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <CustomPatientGroupsRemoveModal
               patientGroupId={props.patientGroupId}
               patientGroupName={props.patientGroupName}
               onClose={closeModal}
            />
         ) : null}
      </>
   );
};
